import api from "./api";

export default class CooperationApi {
  static async get(data) {
    return await api.get(`cooperations`, data);
  }
}
